<template>
  <div class="wrap">
    <h1 class="common-header">
      {{ $t('2002') }}
      <!-- 编辑 -->
      <el-button plain type="primary" v-if="!isEdit && $p('menu.settings.author.edit')" @click="changeEdit(true)">{{
        $t('71')
      }}</el-button>
      <template v-else>
        <!-- 保存 -->
        <el-button type="primary" plain @click="setdepartmentvisit">{{ $t('67') }}</el-button>
        <!-- 取消 -->
        <el-button plain @click="handlerCancel">{{ $t('66') }}</el-button>
      </template>
    </h1>
    <!-- 内容 -->
    <div class="by-content">
      <el-radio-group v-model="radio" :disabled="!isEdit" @change="handlerChange" v-load="loading">
        <!-- 员工可见所有人 -->
        <el-radio label="1"
          >{{ $t('2003') }}
          <el-popover placement="top-start" :title="$t('229')" trigger="hover" :content="$t('2004')">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-radio>
        <div class="by-radio-content" v-if="radio === '1'">
          <el-radio class="text" v-model="radio1" label="10">{{ $t('orgview_1') }}</el-radio>
          <el-checkbox-group v-model="checkList" :disabled="!isEdit">
            <el-checkbox v-for="(item, key) in departmentColumn" :key="key" :label="key">{{ item }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- 员工可见本部门 -->
        <el-radio label="2"
          >{{ $t('2005') }}
          <el-popover placement="top-start" :title="$t('229')" trigger="hover" :content="$t('2006')">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-radio>
        <div class="by-radio-content" v-if="radio === '2'">
          <el-radio class="text" v-model="radio1" label="10">{{ $t('orgview_1') }}</el-radio>
          <el-checkbox-group v-model="checkList" :disabled="!isEdit">
            <el-checkbox v-for="(item, key) in departmentColumn" :key="key" :label="key">{{ item }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <!-- 员工可见不所有人 -->
        <el-radio label="3"
          >{{ $t('2007') }}
          <el-popover placement="top-start" :title="$t('229')" trigger="hover" :content="$t('2008')">
            <i class="el-icon-question" slot="reference"></i> </el-popover
        ></el-radio>
        <div class="by-radio-content" v-if="radio === '3'">
          <!-- 部门负责人可见自己负责的部门 -->
          <el-checkbox v-model="checked" :disabled="!isEdit"
            >{{ $t('2009') }}
            <el-popover placement="top-start" :title="$t('229')" trigger="hover" :content="$t('2010')">
              <i class="el-icon-question" slot="reference"></i> </el-popover
          ></el-checkbox>
          <div class="by-radio-cont" v-if="checked">
            <el-radio class="text" v-model="radio1" label="10">{{ $t('orgview_2') }}</el-radio>
            <el-checkbox-group v-model="checkList" :disabled="!isEdit">
              <el-checkbox v-for="(item, key) in departmentColumn" :key="key" :label="key">{{ item }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
// 获取设置接口
import { getdepartmentvisit, setdepartmentvisit, getdepartmentvisitcolumn } from 'api/settings'
export default {
  data() {
    return {
      checked: false,
      isEdit: false,
      loading: false,
      radio: '3',
      radio1: '5',
      checkList: [],
      departmentColumn: {}
    }
  },
  created() {
    this.getdepartmentvisit()
    this.getDepartment()
  },
  methods: {
    // 开启编辑状态
    changeEdit(v) {
      this.isEdit = v
    },
    async getDepartment() {
      const res = await getdepartmentvisitcolumn()
      if (res.code === 1) {
        this.departmentColumn = res.data.column
      }
    },
    // 获取信息
    async getdepartmentvisit() {
      this.loading = true
      const res = await getdepartmentvisit()
      const { type, column } = res.data
      this.radio = type
      this.checkList = column
      if (type === '31') {
        this.radio = '3'
        this.checked = true
      }
      this.loading = false
    },
    // 保存
    async setdepartmentvisit() {
      // 逻辑同上
      // checkebox 必须在radio等于3才可以选中
      // chekebox 选中则type为31
      const type = this.checked ? '31' : this.radio
      await setdepartmentvisit({ type, column: this.checkList })
      this.changeEdit(false)
    },
    // 取消
    handlerCancel() {
      this.getdepartmentvisit()
      this.changeEdit(false)
    },
    // radio不等于3 则不能选中checkebox
    handlerChange() {
      this.checkList = ['1', '2', '3', '4', '5']
      if (this.radio !== '3') this.checked = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .common-header {
    /deep/ .el-button {
      float: right;
      margin-left: 10px;
    }
  }
  /deep/ .el-radio-group {
    width: 100%;
  }
  /deep/ .el-radio {
    display: block;
    margin: 10px 0;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .by-radio-content {
    margin-left: 25px;
    /deep/.text {
      margin: 0;
      line-height: 30px;
      .el-radio__input {
        display: none;
      }
      .el-radio__label {
        padding-left: 0;
      }
    }
    .by-radio-cont {
      margin-left: 25px;
    }
  }
}
</style>
